<template>
  <div :class="[$style.flow, 'section container']">
    <div :class="$style.caption">{{ t('referral.flow.caption') }}</div>
    <h2 :class="[$style.title, 'h2']">{{ t('referral.flow.title') }}</h2>

    <div :class="$style.list">
      <div
        v-for="(item, index) of flow"
        :key="index"
        :class="$style.item"
      >
        <div :class="$style.itemTitle">{{ item.title }}</div>
        <div :class="$style.itemCaption">{{ item.caption }}</div>

        <img :src="item.image" :alt="item.title" loading="lazy" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
interface FlowItem {
  title: string,
  caption: string,
  image: string,
}

const { t } = useI18n();

const flow = computed<FlowItem[]>(() => [
  {
    title: t('referral.flow.tiles.1.title'),
    caption: t('referral.flow.tiles.1.caption'),
    image: '/images/flow/flow-1.webp',
  }, {
    title: t('referral.flow.tiles.2.title'),
    caption: t('referral.flow.tiles.2.caption'),
    image: '/images/flow/flow-2.webp',
  }, {
    title: t('referral.flow.tiles.3.title'),
    caption: t('referral.flow.tiles.3.caption'),
    image: '/images/flow/flow-3.webp',
  },
]);
</script>

<style lang="scss" module>
  .flow {

  }

  .caption {
    text-align: center;
  }

  .title {
    text-align: center;
    margin: 0 0 32px 0;
  }

  .list {
    display: flex;
    gap: 26px;

    @media (max-width: 767px) {
      flex-direction: column;
      align-items: center;
    }
  }

  .item {
    position: relative;
    flex: 1;
    height: 543px;
    padding: 46px;
    border-radius: 24px;
    background: radial-gradient(38.94% 95.55% at 50% 50%, rgba(247, 247, 247, 0.00) 0%, #F7F7F7 100%);
    overflow: hidden;

    @media (max-width: 1023px) {
      height: 368px;
      padding: 28px;
    }

    @media (max-width: 767px) {
      height: 442px;
      max-width: 398px;
      flex: unset;
    }

    &Title {
      z-index: 2;
      position: relative;
      margin-bottom: 16px;
      font-family: 'Gilroy';
      font-size: 30px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
      color: #000;

      @media (max-width: 1023px) {
        font-size: 24px;
      }
    }

    &Caption {
      z-index: 2;
      position: relative;
      color: rgba(18, 30, 41, 0.70);
      font-size: 14px;
    }

    img {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      object-fit: contain;
      object-position: center bottom;

      @media (max-width: 767px) {
        object-fit: cover;
        object-position: center;
      }
    }
  }
</style>